$(document).ready(function() {
  const $lightboxModal = $('#customLightboxModal');
  const $lightboxOverlay = $('.custom-lightbox-overlay');
  const $lightboxCloseButton = $('.custom-lightbox-close-button');
  const $lightboxImg = $('.custom-lightbox-img');
  const $lightboxTitle = $('#customLightboxTitle');
  const $lightboxDescription = $('#customLightboxDescription');
  const $lightboxCreditContainer = $('.custom-lightbox-credit-container');
  const $lightboxCredit = $('.custom-lightbox-credit');
  const $prevButton = $('.custom-lightbox-prev');
  const $nextButton = $('.custom-lightbox-next');

  let galleryItems = [];
  let currentIndex = 0;
  let $lastFocusedElement = null;
  let isLoadingImage = false; 

  function initializeGalleryItems() {
    galleryItems = [];
    $('.popup-gallery a').each(function() { 
      galleryItems.push({
        src: $(this).attr('href'),
        title: $(this).data('title') || $(this).attr('title') || '',
        description: $(this).data('description') || '',
        credit: $(this).data('credit') || '',
        element: $(this)
      });
    });
  }

  function openLightbox(index) {
    if (isLoadingImage && $lightboxModal.hasClass('is-visible')) {
      return;
    }
    isLoadingImage = true;

    const wasAlreadyOpen = $lightboxModal.hasClass('is-visible');
    currentIndex = index;
    const item = galleryItems[currentIndex];

    // Check if the clicked item's gallery section is our About Us gallery
  if (item.element.closest('#shopify-section-template--24470016360753__gallery_ELQQRE').length > 0) {
    $lightboxModal.addClass('about-us-gallery-active'); 
  } else {
    $lightboxModal.removeClass('about-us-gallery-active');
  }

    const updateTextAndControls = () => {
      $lightboxTitle.text(item.title);
      $lightboxDescription.text(item.description);
      if (item.credit && item.credit.trim() !== '') {
          $lightboxCredit.text(item.credit);
          $lightboxCreditContainer.show();
      } else {
          $lightboxCredit.text('');
          $lightboxCreditContainer.hide();
      }
      if (galleryItems.length > 1) {
        $prevButton.removeClass('is-hidden');
        $nextButton.removeClass('is-hidden');
      } else {
        $prevButton.addClass('is-hidden');
        $nextButton.addClass('is-hidden');
      }
    };

    const onTempImageLoad = function() {
      updateTextAndControls(); 
      $lightboxImg.attr('src', this.src).attr('alt', item.title || 'Gallery image');
      $lightboxImg.stop(true, true).fadeIn(200, () => {
        isLoadingImage = false;
      });

      if (!wasAlreadyOpen) { 
        $lightboxModal.addClass('is-visible').attr('aria-hidden', 'false');
        $lightboxOverlay.css({
            'display': 'block', 'position': 'fixed', 'top': '0px', 'left': '0px',
            'width': '100vw', 'height': '100vh',
            'background-color': 'rgba(18, 18, 18, 0.6)',
            'opacity': '1', 'z-index': '10000' 
        }).show(); 
        disableBodyScroll();
      }
      // Always ensure modal has focus after content is ready (for trapping tabs)
      // but without making an internal element show its focus ring prematurely
      setTimeout(() => { $lightboxModal.focus(); }, 0); // Slight delay to ensure it's focusable
    };

    const onTempImageError = function() {
      console.error("Lightbox: Image failed to load:", item.src);
      updateTextAndControls(); 
      $lightboxImg.attr('alt', 'Image failed to load').show(); 
      isLoadingImage = false;
      if (!wasAlreadyOpen) { 
        $lightboxModal.addClass('is-visible').attr('aria-hidden', 'false');
        $lightboxOverlay.css({
            'display': 'block', 'position': 'fixed', 'top': '0px', 'left': '0px',
            'width': '100vw', 'height': '100vh',
            'background-color': 'rgba(18, 18, 18, 0.6)',
            'opacity': '1', 'z-index': '10000'
        }).show();
        disableBodyScroll();
      }
      // Always ensure modal has focus
      setTimeout(() => { $lightboxModal.focus(); }, 0);
    };

    const $tempImg = $('<img>');
    $tempImg.on('load', onTempImageLoad).on('error', onTempImageError);

    if (wasAlreadyOpen) {
      $lightboxImg.stop(true, true).fadeOut(150, function() {
        $(this).attr('src', ''); 
        $tempImg.attr('src', item.src); 
      });
    } else {
      $lightboxImg.hide().attr('src', '');
      $tempImg.attr('src', item.src); 
    }
  }
  
  function closeLightbox() {
    $lightboxModal.removeClass('is-visible').attr('aria-hidden', 'true');
    $lightboxImg.attr('src', '').stop(true,true).hide(); 
    $lightboxOverlay.css('display', 'none'); 
    if ($lastFocusedElement) {
      $lastFocusedElement.focus();
    }
    enableBodyScroll();
    isLoadingImage = false; 
  }

  function showNextImage() {
    if (galleryItems.length === 0 || (isLoadingImage && $lightboxModal.hasClass('is-visible'))) return;
    let nextIndex = currentIndex + 1;
    if (nextIndex >= galleryItems.length) {
      nextIndex = 0; 
    }
    openLightbox(nextIndex);
  }

  function showPrevImage() {
    if (galleryItems.length === 0 || (isLoadingImage && $lightboxModal.hasClass('is-visible'))) return;
    let prevIndex = currentIndex - 1;
    if (prevIndex < 0) {
      prevIndex = galleryItems.length - 1; 
    }
    openLightbox(prevIndex);
  }

  function disableBodyScroll() {
    $('body').css('overflow', 'hidden');
  }
  function enableBodyScroll() {
    $('body').css('overflow', '');
  }
  
  $(document).on('click', '.popup-gallery a', function(e) {
    e.preventDefault();
    initializeGalleryItems(); 
    $lastFocusedElement = $(this); 
    let clickedIndex = -1;
    for(let i = 0; i < galleryItems.length; i++) {
        if (galleryItems[i].element.is($(this))) {
            clickedIndex = i;
            break;
        }
    }
    if (clickedIndex !== -1) {
      openLightbox(clickedIndex);
    } else {
      console.warn("Lightbox: Clicked item not found.");
    }
  });

  $lightboxCloseButton.on('click', closeLightbox);
  $lightboxOverlay.on('click', closeLightbox); 
  $prevButton.on('click', showPrevImage);
  $nextButton.on('click', showNextImage);

  $(document).on('keydown', function(e) {
    if ($lightboxModal.hasClass('is-visible')) {
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight' && !$nextButton.hasClass('is-hidden')) showNextImage(); 
      if (e.key === 'ArrowLeft' && !$prevButton.hasClass('is-hidden')) showPrevImage(); 
      if (e.key === 'Tab') {
        const focusableElements = $lightboxModal.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible');
        const firstFocusable = focusableElements.first();
        const lastFocusable = focusableElements.last();
        if (e.shiftKey && document.activeElement === firstFocusable[0]) {
          lastFocusable.focus(); e.preventDefault();
        } else if (!e.shiftKey && document.activeElement === lastFocusable[0]) {
          firstFocusable.focus(); e.preventDefault();
        }
      }
    }
  });

  initializeGalleryItems(); 
  $(document).on('shopify:section:load', function(event) {
    if ($(event.target).find('.popup-gallery').length > 0) initializeGalleryItems();
  });
});